import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import WorkspaceDetailBlock from "../../Components/Workspace/WorkspaceDetail";
import PageHeader from "../../Components/Common/PageHeader";

const WorkspaceDetailPage = () => {
  const { workspaceId } = useParams();

  useEffect(() => {
    Utils.setPageTitle("Workspace Detail");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader 
          title="Workspace Detail" 
          description="Manage workspace members and settings" 
          icon={faUsers} 
        />

        <WorkspaceDetailBlock workspaceId={workspaceId} />
      </div>
    </main>
  );
};

export default WorkspaceDetailPage;
